import toepenApp from '../assets/images/apps/toepen-icon.png';
import stridesApp from '../assets/images/apps/strides-icon.png';
import shareBoatApp from '../assets/images/apps/shareboat-icon.png';

export const apps = [
  {
    id: 'toepen-scorekaart',
    name: 'Toepen Scorekaart',
    imageUrl: toepenApp,
    privacyPolicy: `
      <h3 class="text-2xl font-bold tracking-tight text-gray-900">Privacy Policy for Toepen Scorekaart</h3>
      <p class="mt-4">Effective Date: 24-07-2024</p>
      <p class="mt-4">This Privacy Policy describes how Toepen Scorekaart ("we," "us," or "our") collects, uses, and discloses your information when you use our mobile application (the "Service").</p>
      
      <h4 class="text-xl font-bold tracking-tight text-gray-900 mt-6">1. Information We Collect</h4>
      <p class="mt-4">We may collect and store information you provide directly to us, such as:</p>
      <ul class="list-disc list-inside mt-4">
        <li>Information you provide when you create an account, such as your name, email address, and password.</li>
        <li>User content, such as text, images, and other materials you post to the Service.</li>
        <li>Communications between you and us, such as for customer support.</li>
      </ul>
      
      <h4 class="text-xl font-bold tracking-tight text-gray-900 mt-6">2. How We Use Your Information</h4>
      <p class="mt-4">We may use the information we collect for various purposes, including to:</p>
      <ul class="list-disc list-inside mt-4">
        <li>Provide, maintain, and improve our Service.</li>
        <li>Personalize your experience.</li>
        <li>Communicate with you about products, services, offers, and events.</li>
        <li>Monitor and analyze trends, usage, and activities in connection with our Service.</li>
      </ul>

      <h4 class="text-xl font-bold tracking-tight text-gray-900 mt-6">3. Sharing of Information</h4>
      <p class="mt-4">We may share information about you as follows or as otherwise described in this Privacy Policy:</p>
      <ul class="list-disc list-inside mt-4">
        <li>With vendors, consultants, and other service providers who need access to such information to carry out work on our behalf.</li>
        <li>In response to a request for information if we believe disclosure is in accordance with, or required by, any applicable law, regulation, or legal process.</li>
        <li>If we believe your actions are inconsistent with our user agreements or policies, or to protect the rights, property, and safety of us or others.</li>
      </ul>
    `,
  },
  {
    id: 'bootje-delen',
    name: 'Bootje Delen',
    imageUrl: shareBoatApp,
    privacyPolicy: `
      <h3 class="text-2xl font-bold tracking-tight text-gray-900">Privacy Policy for Bootje Delen</h3>
      <p class="mt-4">Effective Date: 24-07-2024</p>
      <p class="mt-4">This Privacy Policy describes how Bootje Delen ("we," "us," or "our") collects, uses, and discloses your information when you use our mobile application (the "Service").</p>
      
      <h4 class="text-xl font-bold tracking-tight text-gray-900 mt-6">1. Information We Collect</h4>
      <p class="mt-4">We may collect and store information you provide directly to us, such as:</p>
      <ul class="list-disc list-inside mt-4">
        <li>Information you provide when you create an account, such as your name, email address, and password.</li>
        <li>User content, such as text, images, and other materials you post to the Service.</li>
        <li>Communications between you and us, such as for customer support.</li>
      </ul>
      
      <h4 class="text-xl font-bold tracking-tight text-gray-900 mt-6">2. How We Use Your Information</h4>
      <p class="mt-4">We may use the information we collect for various purposes, including to:</p>
      <ul class="list-disc list-inside mt-4">
        <li>Provide, maintain, and improve our Service.</li>
        <li>Personalize your experience.</li>
        <li>Communicate with you about products, services, offers, and events.</li>
        <li>Monitor and analyze trends, usage, and activities in connection with our Service.</li>
      </ul>

      <h4 class="text-xl font-bold tracking-tight text-gray-900 mt-6">3. Sharing of Information</h4>
      <p class="mt-4">We may share information about you as follows or as otherwise described in this Privacy Policy:</p>
      <ul class="list-disc list-inside mt-4">
        <li>With vendors, consultants, and other service providers who need access to such information to carry out work on our behalf.</li>
        <li>In response to a request for information if we believe disclosure is in accordance with, or required by, any applicable law, regulation, or legal process.</li>
        <li>If we believe your actions are inconsistent with our user agreements or policies, or to protect the rights, property, and safety of us or others.</li>
      </ul>
    `,
  },
  {
    id: 'mystrides',
    name: 'MyStrides',
    imageUrl: stridesApp,
    privacyPolicy: `
      <h3 class="text-2xl font-bold tracking-tight text-gray-900">Privacy Policy for MyStrides</h3>
      <p class="mt-4">Effective Date: 24-07-2024</p>
      <p class="mt-4">This Privacy Policy describes how MyStrides ("we," "us," or "our") collects, uses, and discloses your information when you use our mobile application (the "Service").</p>
      
      <h4 class="text-xl font-bold tracking-tight text-gray-900 mt-6">1. Information We Collect</h4>
      <p class="mt-4">We may collect and store information you provide directly to us, such as:</p>
      <ul class="list-disc list-inside mt-4">
        <li>Information you provide when you create an account, such as your name, email address, and password.</li>
        <li>User content, such as text, images, and other materials you post to the Service.</li>
        <li>Communications between you and us, such as for customer support.</li>
      </ul>
      
      <h4 class="text-xl font-bold tracking-tight text-gray-900 mt-6">2. How We Use Your Information</h4>
      <p class="mt-4">We may use the information we collect for various purposes, including to:</p>
      <ul class="list-disc list-inside mt-4">
        <li>Provide, maintain, and improve our Service.</li>
        <li>Personalize your experience.</li>
        <li>Communicate with you about products, services, offers, and events.</li>
        <li>Monitor and analyze trends, usage, and activities in connection with our Service.</li>
      </ul>

      <h4 class="text-xl font-bold tracking-tight text-gray-900 mt-6">3. Sharing of Information</h4>
      <p class="mt-4">We may share information about you as follows or as otherwise described in this Privacy Policy:</p>
      <ul class="list-disc list-inside mt-4">
        <li>With vendors, consultants, and other service providers who need access to such information to carry out work on our behalf.</li>
        <li>In response to a request for information if we believe disclosure is in accordance with, or required by, any applicable law, regulation, or legal process.</li>
        <li>If we believe your actions are inconsistent with our user agreements or policies, or to protect the rights, property, and safety of us or others.</li>
      </ul>
    `,
  },
]; 